import { Card } from "@/components/ui/card";
import { Bell, Package, ShoppingBag, Users } from "lucide-react";

const notifications = [
  {
    id: 1,
    title: "New Order Received",
    message: "Order #1234 has been placed",
    icon: ShoppingBag,
    time: "5 minutes ago",
    type: "order"
  },
  {
    id: 2,
    title: "Low Stock Alert",
    message: "Product 'Electronics Package' is running low",
    icon: Package,
    time: "2 hours ago",
    type: "inventory"
  },
  {
    id: 3,
    title: "New Customer Registration",
    message: "John Doe has created an account",
    icon: Users,
    time: "1 day ago",
    type: "customer"
  }
];

const Notifications = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl md:text-3xl font-bold">Notifications</h1>
      </div>
      
      <Card className="divide-y">
        {notifications.map((notification) => (
          <div
            key={notification.id}
            className="p-4 md:p-6 flex items-start gap-4 hover:bg-gray-50 transition-colors"
          >
            <div className={`p-2 rounded-lg ${
              notification.type === 'order' ? 'bg-blue-100' :
              notification.type === 'inventory' ? 'bg-yellow-100' :
              'bg-green-100'
            }`}>
              <notification.icon className={`h-6 w-6 ${
                notification.type === 'order' ? 'text-blue-600' :
                notification.type === 'inventory' ? 'text-yellow-600' :
                'text-green-600'
              }`} />
            </div>
            <div className="flex-1">
              <h3 className="font-medium">{notification.title}</h3>
              <p className="text-sm text-muted-foreground">{notification.message}</p>
              <p className="text-xs text-muted-foreground mt-1">{notification.time}</p>
            </div>
          </div>
        ))}
      </Card>
    </div>
  );
};

export default Notifications;